module.exports = __webpack_public_path__ + "static/media/brush-color.5f7fc223.svg";